export default __webpack_public_path__ + "static/media/dat.315535bb.svg";